import { useEffect, useState } from "react";
import { atom, useSetRecoilState, useRecoilValue } from "recoil";
import { authAtom } from "../../Connect/_state";
import { useUserActions } from "../../Connect/_actions";
import { addDataIntoCache, getSingleCacheData } from "../Cache/cache";
import CollectionParAffaire from "../Model/CollectionsParAffaire";
import FormDocMetadata from "../Model/FormDocMetadata";
import Collection from "../Model/Collection";
import Affaire from "../Model/Affaire";
import Document from "../Model/Document";
import ExternalVerifDocument from "../Model/ExternalVerifDocument";
import User from "../Model/User";
import { Role } from "../Useful/enum";

const cls: Collection[] = [];
export const collectionsAtom = atom({
    key: 'collections',
    default: cls
})

export const recentCollectionsAtom = atom({
    key: 'recentCollections',
    default: cls
})

export const justDownloadedCollectionsAtom = atom({
    key: 'justDownloadedCollections',
    default: cls
})

const cpa: CollectionParAffaire[] = [new CollectionParAffaire()];
export const listCollectionsByAffaireAtom = atom({
    key: 'listCollectionsByAffaire',
    default: cpa
})

export const isListCollectionsByAffaireLoadedAtom = atom({
    key: 'isListCollectionsByAffaireLoaded',
    default: false
})

export const areCollectionsLoadedAtom = atom({
    key: 'areCollectionsLoaded',
    default: false
})

const fdm: FormDocMetadata[] = [];
export const documentMetaListAtom = atom({
    key: 'documentMetaList',
    default: fdm
})

const uds: Document[] = [];
export const uploadedDocumentsAtom = atom({
    key: 'uploadedDocuments',
    default: uds
})

export const justSentDocsAtom = atom({
    key: 'justSentDocs',
    default: uds
})

export const areUploadedDocumentsLoadedAtom = atom({
    key: 'areUploadedDocumentsLoaded',
    default: false
})

export const areUploadedDocumentsLoadingAtom = atom({
    key: 'areUploadedDocumentsLoading',
    default: false
})

const evd: ExternalVerifDocument[] = [];
export const externalVerifDocumentsAtom = atom({
    key: 'externalVerifDocuments',
    default: evd
})

export const areExternalVerifDocumentsLoadedAtom = atom({
    key: 'areExternalVerifDocumentsLoaded',
    default: false
})

const ena: number[] = [];
export const idCollectionsDownloadingAtom = atom({
    key: 'idCollectionsDownloading',
    default: ena
})

export const idNavettesDownloadingAtom = atom({
    key: 'idNavettesDownloading',
    default: ena
})

export const isAlertContractsOpenAtom = atom({
    key: 'isAlertContractsOpen',
    default: true
})

export const isAlertCollectionsOpenAtom = atom({
    key: 'isAlertCollectionsOpen',
    default: true
})

export default function LoadData(user: User) {
    const auth = useRecoilValue(authAtom);
    const userActions = useUserActions();
    const setCollections = useSetRecoilState(collectionsAtom);
    const setAreCollectionsLoaded = useSetRecoilState(areCollectionsLoadedAtom);
    const setRecentCollections = useSetRecoilState(recentCollectionsAtom);
    const setListCollectionsByAffaire = useSetRecoilState(listCollectionsByAffaireAtom);
    const setIsListCollectionsByAffaireLoaded = useSetRecoilState(isListCollectionsByAffaireLoadedAtom);
    const setDocumentMetaList = useSetRecoilState(documentMetaListAtom);
    const setUploadedDocuments = useSetRecoilState(uploadedDocumentsAtom);
    const setAreUploadedDocumentsLoaded = useSetRecoilState(areUploadedDocumentsLoadedAtom);
    const setAreUploadedDocumentsLoading = useSetRecoilState(areUploadedDocumentsLoadingAtom);
    const setExternalVerifDocuments = useSetRecoilState(externalVerifDocumentsAtom);
    const setAreExternalVerifDocumentsLoaded = useSetRecoilState(areExternalVerifDocumentsLoadedAtom);
    const [isDataLoaded, setStateLoad] = useState(false);

    useEffect(() => {
        const getDataFromCache = () => {
            getSingleCacheData('collections', auth.username, setCollections);
            getSingleCacheData('listeCollectionsParAffaire', auth.username, setListCollectionsByAffaire);
        }

        const updateAffaires = (listeDesCollectionsParAffaire: CollectionParAffaire[]) => {
            setListCollectionsByAffaire(listeDesCollectionsParAffaire);
            setIsListCollectionsByAffaireLoaded(true);
            addDataIntoCache('listeCollectionsParAffaire', auth.username, listeDesCollectionsParAffaire);
        }
    
        const startLoading = () => {
            getDataFromCache();
            userActions.getRecentCollections(setRecentCollections);
            userActions.getAffaires().then((affaires: Affaire[]) => {
                userActions.getCollections(new Affaire()).then((collections: Collection[]) => { // renvoie toutes les collections
                    userActions.updateCollections(collections, setAreCollectionsLoaded);
                })
                let listeDesCollectionsParAffaire: CollectionParAffaire[] = [new CollectionParAffaire()];
                if (affaires.length === 0) {
                    updateAffaires(listeDesCollectionsParAffaire);
                }
                affaires.forEach((affaire: Affaire) => {
                    userActions.getCollections(affaire).then((collections: Collection[]) => {
                        let CollectionsParAffaire: CollectionParAffaire = { affaire: affaire, collections: collections };
                        listeDesCollectionsParAffaire.push(CollectionsParAffaire);
                        if (affaires.length + 1 === listeDesCollectionsParAffaire.length) { // + 1 car il y a l'option 'Tous' pour afficher toutes les collections de toutes les affaires
                            updateAffaires(listeDesCollectionsParAffaire);
                        }
                    })
                })
            })
            userActions.getDocumentMetaList().then((documentMetaList: FormDocMetadata[]) => {
                setDocumentMetaList(documentMetaList);
            }).catch((error:any) => console.log(error))
            setAreUploadedDocumentsLoading(true);
            /*userActions.getUploadedDocuments(10).then((uploadedDocuments: Document[]) => {
                setUploadedDocuments(uploadedDocuments);
                // setAreUploadedDocumentsLoaded(true)
            }).catch((error:any) => console.log(error))*/
            userActions.getUploadedDocuments(0).then((uploadedDocuments: Document[]) => { // 0 = tous les documents
                setUploadedDocuments(uploadedDocuments);
                setAreUploadedDocumentsLoaded(true);
                setAreUploadedDocumentsLoading(false);
            }).catch((error:any) => {console.log(error); setAreUploadedDocumentsLoading(false)})
            userActions.getExternalVerifDocuments().then((extDocuments: ExternalVerifDocument[]) => {
                setAreExternalVerifDocumentsLoaded(true);
                setExternalVerifDocuments(extDocuments);
            })
        }
        if (!isDataLoaded && user.role === Role.PermUser) {
            setStateLoad(true);
            startLoading();
        }
    }, [isDataLoaded, auth.username, setAreCollectionsLoaded, setAreUploadedDocumentsLoaded, setCollections, setDocumentMetaList, setExternalVerifDocuments, setIsListCollectionsByAffaireLoaded, setListCollectionsByAffaire, setRecentCollections, setUploadedDocuments, setAreUploadedDocumentsLoading, setAreExternalVerifDocumentsLoaded, userActions, user.role])
}